// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"0e48f8df","555":"17d92ceb","587":"1cc27dbe","823":"d8467cff"}[chunkId] + ".chunk.js";
};